import React from 'react';
import SerialMonitor from './SerialMonitor'; // Import the SerialMonitor component
import APIKeyTable from './APIKeyTable';
import RobotStatus from './RobotStatus';
import DevicePairing from './DevicePairing';
import { CContainer, CRow, CCol } from '@coreui/react';
import config from '../../../utils/EnvironmentSwitcher'; // Import config utility
// Retrieve the FHIR token from props or localStorage
//const fhirToken = localStorage.getItem('mieFToken');
const KeysLayout = ({ authUser, fhirToken }) => {
  return (
    <div className="wrapper d-flex flex-column min-vh-100 bg-light">
      {/* Optional: Uncomment if you want to include header and footer */}
      {/* <AppHeader /> */}
      <div className="body flex-grow-1 px-3">
        <CContainer className="mt-4">
          <CRow className="justify-content-center">
            <CCol lg={10}>
              <h2 className="text-center mb-4 text-primary">API Keys and Robot Status</h2>
              <p className="text-center mb-2">
                Manage your API keys and monitor the status of your linked robots.
                {config.environment === 'development' && (
                  <span className="badge bg-warning ms-2">Development Mode</span>
                )}
              </p>
              {config.environment === 'development' && (
                <div className="environment-info">
                  <p>
                    <strong>Environment:</strong> {config.environment}
                    <span className="development-mode-indicator ms-2">Development Mode</span>
                  </p>
                  <p>
                    <strong>FHIR URL:</strong> <span className="fhir-url">{config.fhirUrl}</span>
                  </p>
                </div>
              )}
              <APIKeyTable fhirToken={fhirToken} authUser={authUser} />
            </CCol>
          </CRow>
          <CRow className="justify-content-center mt-4">
            <CCol lg={10}>
              <RobotStatus fhirToken={fhirToken} authUser={authUser} />

            </CCol>
          </CRow>
          <CRow className="justify-content-center mt-4">
            <CCol lg={10}>
              <DevicePairing fhirToken={fhirToken} authUser={authUser} />
            </CCol>
          </CRow>
          <CRow className="justify-content-center mt-4">
            <CCol lg={10}>
              <SerialMonitor /> {/* Add the SerialMonitor component here */}
            </CCol>
          </CRow>
        </CContainer>
      </div>
      {/* <AppFooter /> */}
    </div>
  );
};

export default KeysLayout;


